export default "__VITE_ASSET__DHKfG3vV__"